import React, { Component } from 'react';
import loadImage from '../../utils/loadImage';
import style from './ScreenedImageCover.module.scss';

class ScreenedImageCover extends Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
      reveal: false,
    };
  }
  componentDidUpdate(prevProps) {
    if (
      !this.startedLoad &&
      prevProps.load !== this.props.load &&
      this.props.load
    ) {
      this.load();
    }
  }
  componentDidMount() {
    // if no load prop, or its true, load
    if (typeof this.props.load === 'undefined' || this.props.load) {
      this.load();
    }
  }
  // componentWillReceiveProps(nextProps) {
  //   if (!this.startedLoad && !this.props.revealed && nextProps.revealed) {
  //     this.load();
  //   }
  // }
  load() {
    this.startedLoad = true;
    loadImage(this.props.url).then(img => {
      this.setState({ loaded: true }, () => {
        setTimeout(() => {
          this.setState({ reveal: true });
        }, 1);
      });
    });
  }
  render() {
    const display = this.state.reveal;

    return (
      <div
        className={style.image}
        style={{
          backgroundImage: `url(${this.state.loaded ? this.props.url : ''})`,
          opacity: this.state.reveal && !this.props.hide ? 1 : 0,
        }}
      />
    );
  }
}

export default ScreenedImageCover;



// WEBPACK FOOTER //
// ./src/components/ui/ScreenedImageCover.js